import * as Constants from './Constants';

const initialState = {
  isFetching: true,
  title: 'Appointment Schedule',
  isSubmitSuccess: false,
  errorSubmit: false,
  showError: false,
  showAppointmentCTA: false,
  skipOrderWriteEtos: false,
  dateObj: {
    selectedDateR: null,
    selectedDayR: null,
  },
  selectedSlotR: null,
  reminderTypeR: 'Call',
  emailIdR: '',
  phoneNumberR: '',
  CTAdisabled: false,
  specInstR: '',
  orderwriteCaseError: false,
  appointmentServiceInfo: null,
  paymentError: false,
  appointmentPageError: false,
  noSlot: false,
  appointmentError: false,
  appointmentNtfyMsg: null,
  isValidProSetupData: true,
  orderWriteResponse: {},
  isNonVzConsentCheckboxChecked: false,
};
function appointmentSchedule(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, title: action?.response?.data };
    case Constants.ERORR_SUBMIT: {
      return { ...state, errorSubmit: action.errorDetails, appointmentServiceInfo: action.serviceinfo };
    }
    case Constants.GET_DATA_FROM_APP_SCHEDULE_SUCCESS:
      // performanceMeasure('appointment', 60);
      return { ...state, appointmentScheduleResponse: action.response, isFetching: false };
    case Constants.GET_DATA_FROM_APP_SCHEDULE_FAIL:
      return { ...state, appointmentScheduleResponse: action.response, isFetching: false };
    case Constants.POST_DATA_SELF_INSTALLATION_SUCCESS:
      return { ...state, updateSelfInstallationResponse: action.response };
    case Constants.POST_DATA_PRO_INSTALLATION_SUCCESS:
      return { ...state, updateProInstallationResponse: action.response };
    case Constants.NO_SLOTS_AVAILABLE:
      return { ...state, noSlotsAvailable: action.response };
    case Constants.SUBMIT_SUCCESS: {
      // return { ...state, isSubmitSuccess: action.response };
      const preState = state.isSubmitSuccess;
      if (action.flagToggle) {
        return { ...state, isSubmitSuccess: preState, orderSubmitResponse: action.response };
      }
      return { ...state, isSubmitSuccess: !preState };
    }
    case 'SKIP_ORDERWRITE-ETOS': {
      // return { ...state, isSubmitSuccess: action.response };
      const preState = state.skipOrderWriteEtos;
      return { ...state, skipOrderWriteEtos: !preState };
    }
    case Constants.SUBMIT_SUCCESS_ORDERWRITE: {
      return { ...state, orderWriteResponse: action.response };
    }
    // return { ...state, setupOption: action.response };
    case 'SAVE_SELF_INSTALL_DATE_SUCCES':
      return { ...state, selfInstallDate: action.response };
    case Constants.ERR_OCCURED:
      return { ...state, showError: action.errorAppointment, appointmentServiceInfo: action.serviceinfo };
    // case 'NBS_RECEIVED_APPOINTMENT':
    //   return {
    //     ...state,
    //     nbsVo: action.response,
    //     nbsLoaded: true,
    //     nbsApiError: false,
    //   };
    case 'APPOINTMENT_CTA':
      return { ...state, showAppointmentCTA: action.data };
    case 'SAVE_SELECTED_DATE':
      return {
        ...state,
        dateObj: {
          selectedDateR: action.dateR,
          selectedDayR: action.dayR,
        },
      };
    case 'SAVE_SELECTED_SLOT':
      return { ...state, selectedSlotR: action.slot };
    case 'SAVE_REMINDER_TYPE':
      return { ...state, reminderTypeR: action.reminderType };
    case 'SAVE_EMAIL_ID':
      return { ...state, emailIdR: action.email, CTAdisabled: action.CTAdisabled };
    case 'SAVE_PHONE_NO':
      return { ...state, phoneNumberR: action.phoneNo, CTAdisabled: action.CTAdisabled };
    case 'SAVE_IS_VALID_PRO_SETUP_DATA':
      return { ...state, isValidProSetupData: action.isValidProSetupData };
    case 'SAVE_SPEC_INSTRC':
      return { ...state, specInstR: action.specInst };
    case 'SAVE_CTAdisabled':
      return { ...state, CTAdisabled: action.CTAdisabled };
    case Constants.ORDERWRITE_CASE_ERROR:
      return { ...state, orderwriteCaseError: action.response, appointmentServiceInfo: action.serviceinfo };
    case 'EMAIL_VALIDATION':
      return { ...state, emailAPiResponse: action.response, accMainEmailVal: action.response.accMainEmailVal };
    case Constants.ACC_MAIN_EMAIL_VALIDATION:
      return { ...state, accMainEmailVal: action.response };
    case 'NOT_SUBMITTED_PAYMENT':
      return { ...state, paymentError: action.notSubmittedPayment, appointmentServiceInfo: action.serviceinfo };
    case 'NO_APPOINTMENT':
      return { ...state, appointmentPageError: action.noAppointment, appointmentServiceInfo: action.serviceinfo };
    case 'IS_UPDATE_APPOINTMENT_SUCCESS':
      return { ...state, noSlot: action.response };
    case Constants.CEF_APPOINTMENT_ERROR:
      return { ...state, appointmentError: action.response, appointmentNtfyMsg: action.errorMessage };
    case Constants.NON_VZ_CHECKBOX_VALUE:
      return { ...state, isNonVzConsentCheckboxChecked: action.payload };
    default:
      return state;
  }
}
export default appointmentSchedule;
